// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__SaSTp","btn":"Navbar_btn__400Yb"};